import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const StoreSelect = ({ value, onChange, className = '', style = {} }) => {
  const { token, user } = useAuth();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;
    
    setLoading(true);
    const isStaff = user?.role === 'staff';
    const url = isStaff ? '/api/store-permissions/export-stores' : '/api/stores';
    fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        // Send optional owner/staff identifiers for downstream auditing (JWT remains the source of truth)
        'X-Owner-Id': user?.ownerId || user?.owner_id || user?.id || '',
        'X-Staff-Id': isStaff ? (user?.staffId || user?.id || '') : ''
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error('Failed to fetch stores');
        }
        return res.json();
      })
      .then(data => {
        const list = Array.isArray(data) ? data : (data?.items || []);
        setStores(list);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching stores:', error);
        setLoading(false);
      });
  }, [token, user]);

  return (
    <select
      className={`form-select ${className}`}
      style={style}
      value={value || (stores.length > 0 ? stores[0].id || stores[0].ID : '')}
      onChange={e => onChange && onChange(Number(e.target.value))}
      disabled={loading}
    >
      {stores.map(store => (
        <option key={store.id || store.ID} value={store.id || store.ID}>
          {store.name}
        </option>
      ))}
    </select>
  );
};

export default StoreSelect;
